import { Helmet } from 'react-helmet'

const JsonLd = props => {
  const jsonld = {
    '@context': 'http://schema.org',
    ...props,
  }

  return (
    <Helmet>
      <script type="application/ld+json">{JSON.stringify(jsonld)}</script>
    </Helmet>
  )
}

export default JsonLd
